export const SUBSCRIBE_EMAIL_FORM = 'js-email-subscription-form';
export const SUBSCRIBE_EMAIL_SECTION = 'js-email-subscription';
export const SUBSCRIBE_EMAIL_SUCCESS = 'js-email-subscription-success';
export const SUBSCRIBE_EMAIL_INPUT = 'js-subscribe-email-input';
export const SUBSCRIBE_EMAIL_BUTTON = 'js-subscribe-email-button';
export const SUBSCRIBE_EMAIL_TITLE = 'js-email-subscription-title';
export const SUBSCRIBE_EMAIL_DESCRIPTION = 'js-email-subscription-description';
